import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';

import { MetaReducer, USER_PROVIDED_META_REDUCERS } from '@ngrx/store';

import { LogConfiguration } from './models/log-configuration.model';
import { LOGGER, SENSITIVEACTIONS } from './models/token.model';
import { AggregatedLoggerService } from './services/aggregated-logger.service';
import { LogErrorHandler } from './services/log-error-handler';
import { RootState } from '../../store/root-state.model';
import { ConsoleLoggerService } from './services/providers/console-logger.service';

export function loggerMetaReducerFactory(
  logger: AggregatedLoggerService
): MetaReducer<RootState>[] {
  return [(reducer) => logger.createLogReducer(reducer)];
}

@NgModule({
  imports: [CommonModule],
})
export class LoggingModule {
  public static forRoot(configuration: LogConfiguration): ModuleWithProviders<LoggingModule> {
    return {
      ngModule: LoggingModule,
      providers: [
        (configuration.enableConsoleLog
          ? [ConsoleLoggerService, ...configuration.logProviders]
          : configuration.logProviders
        ).map((providerType) => ({ provide: LOGGER, useClass: providerType, multi: true })),
        AggregatedLoggerService,
        { provide: ErrorHandler, useClass: LogErrorHandler },
        { provide: SENSITIVEACTIONS, useValue: configuration.sensitiveActions },
        {
          provide: USER_PROVIDED_META_REDUCERS,
          deps: [AggregatedLoggerService],
          useFactory: loggerMetaReducerFactory,
        },
      ],
    };
  }
}
